<div class="card w-100 transaction-card transaction-upload-temp m-0">
  <div class="card p-3 m-0 d-flex flex-column align-items-center">
    <div class="upload-section text-center">
      <div class="form-group">
        <label for="" class="form-label"><b>Upload MT103</b></label>
      </div>

      <div class="form-group">
        <a
          target="_blank"
          class="download-link-a text-nowrap cursor-pointer"
          (click)="downloadTemplate()"
        >
          Download Template
        </a>
        <br />
        <div>
          <!--<div class="d-flex justify-content-center align-items-center position-relative validate-update mb-2">
            <button
              type="button"
              (click)="fileInput1.click()"
              class="btn-cls d-flex align-items-center justify-content-center"
            >
              Validate File
              <img
                alt=""
                class="img1 ms-1"
                src="assets/images/icon/upload.png"
                width="18"
              />
            </button>
            <input
              (change)="fileChangeValidate($event)"
              #fileInput1
              type="file"
              name="file"
              id="fileValidate"
              hidden
              #fileUploader
            />
            <div class="loader_gif" *ngIf="showValidateLoader">
              <img
                alt=""
                width="20px"
                src="assets/images/icon/loader-1.gif"
              />
            </div>
          </div>-->
          <div class="d-flex justify-content-center align-items-center position-relative validate-update">
            <button
              type="button"
              class="btn-cls d-flex align-items-center justify-content-center"
              (click)="fileInput.click()"
            >
              Upload Data
              <img
                alt=""
                class="img1 ms-1"
                src="assets/images/icon/upload.png"
                width="18"
              />
            </button>
            <input
              (change)="fileChange($event)"
              #fileInput
              type="file"
              name="file"
              id="file"
              hidden
              #fileUploader
            />
            <div class="loader_gif" *ngIf="showUploadLoader">
              <img
                alt=""
                width="20px"
                src="assets/images/icon/loader-1.gif"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
